import React, {  } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Grid from "@material-ui/core/Grid/Grid";

import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import Typography from "@material-ui/core/Typography";

import TipoCorrecaoPieChart from "./TipoCorrecaoPieChart";
import CorrecaoParametrosBarChart from "./CorrecaoParametrosBarChart";


const useStyles = makeStyles(theme => ({

    mainGrid: {
      margin: 0,
      display: 'flex',
      height: '140mm',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      alignContent: 'flex-start',
      border: 1,
      borderStyle: 'solid',
      borderColor: 'black',
      borderRadius: '5px',
      flexGrow: 0
    },
    gridTitulo: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'flex-start',


        border: 1,
   //     borderStyle: 'solid',
        borderColor: 'black',
        borderRadius: '5px'
    },
    gridItem: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: "center",
        alignContent: 'center',
        border: 1,
    //    borderStyle: 'solid',
        borderColor: 'black',
        borderRadius: '5px'
    },


}));

const renderLoadingScreen = () => {
    const { classes } = this.props;
    return (
        <React.Fragment>
            {this.renderSearchComponent()}
            <div align="center">
                <CircularProgress className={classes.progress} />
            </div>
        </React.Fragment>
    )
}

export default function Correcoes(props) {
  const { raspaReportData} = props;

  const classes = useStyles();


    return (
    <Grid container xs={12} className={classes.mainGrid}>
        <Grid container item id={'titulo'} className={classes.gridTitulo} sm={12} md={12}>
            <Typography>RASPAGENS COM CORREÇÕES REALIZADAS - TOTAL DE RASPAGENS: {raspaReportData.periodo.totaisGerais.numCiclos40SegValidos}</Typography>
        </Grid>
        <Grid container item id={'titulo'} className={classes.gridTitulo} style={{ padding: '2px'}} sm={12} md={12}>
            <Grid container item id={'gridCorrecaoLado'} className={classes.gridItem} sm={4} md={4} >
                <TipoCorrecaoPieChart data={raspaReportData.periodo.totaisCorrecoes}

                                      titulo={"LADO"}
                                      dataKeyX={"hora"}
                                      height={200} width={200} legenda={false}/>
            </Grid>

            <Grid container item id={'gridCorrecaoAjuste'} className={classes.gridItem}  sm={8} md={8} >

                <CorrecaoParametrosBarChart data={raspaReportData.periodo.correcoesRaspagem}

                                      titulo={"# RASP. / PARAMETRO CORREÇÃO"}
                                      dataKeyX={"hora"}
                                      height={250} width={500} legenda={false} maxBarSize={20}/>

            </Grid>
        </Grid>
    </Grid>
  )
}
;
